import { LogLevel, OpenIdConfiguration, PassedInitialConfig } from 'angular-auth-oidc-client';

import ENV_NAMES from '../../environments/ENV_NAMES';
import { AppConfig } from '../shared/models/AppConfig';
import { UserType } from '../shared/models/User';

export const AUTH_CONFIG_IDS: Record<string, UserType> = {
    INSTALLER: 'installer',
    OWNER: 'owner',
} as const;

export type AuthConfigId = (typeof AUTH_CONFIG_IDS)[keyof typeof AUTH_CONFIG_IDS];

export function getAuthConfig(config: AppConfig): PassedInitialConfig {
    const logLevel = [ENV_NAMES.PROD, ENV_NAMES.PREPROD].includes(config.name) ? LogLevel.Error : LogLevel.Warn;

    const isWiremock = config.name === ENV_NAMES.WIREMOCK;

    const baseConfig: OpenIdConfiguration = {
        authority: config.oauth2.url,
        postLogoutRedirectUri: config.sso.logoutUrl,
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        ignoreNonceAfterRefresh: true,
        logLevel,
        autoCleanStateAfterAuthentication: false,
        ...(isWiremock && {
            disableIdTokenValidation: true,
            disableIatOffsetValidation: true,
            disableRefreshIdTokenAuthTimeValidation: true,
            autoUserInfo: false,
        }),
    };

    return {
        config: [
            {
                ...baseConfig,
                configId: AUTH_CONFIG_IDS.INSTALLER,
                clientId: config.oauth2.clientId,
                redirectUrl: `${window.location.origin}/sites`,
            },
            {
                ...baseConfig,
                configId: AUTH_CONFIG_IDS.OWNER,
                clientId: config.oauth2.endUser.clientId,
                redirectUrl: `${window.location.origin}/enduser/auth`,
            },
        ],
    };
}
